import { isEmpty } from 'lodash';
import { Accident } from '../../types/accident';

export const cleanAccidentData = (data: Accident): Accident => {
  const cleanOperator = () => {
    // Pokud není operator vůbec nastaven v datech, vrátíme undefined
    if (!data.operator) return undefined;

    if (data.operator?.equalTo === 'user') {
      return { equalTo: 'user' as const };
    }
    if (!data.operator || Array.isArray(data.operator) || isEmpty(data.operator)) {
      return { equalTo: 'user' as const };
    }
    return { ...data.operator, equalTo: 'none' as const };
  };

  const cleanPersonRef = (person: any) => {
    if (!person) return undefined;
    if (!person?.equalTo || person.equalTo === 'none') {
      return { ...person, equalTo: 'none' as const };
    }
    return { equalTo: person.equalTo };
  };

  return {
    ...data,
    operator: cleanOperator(),
    driver: cleanPersonRef(data.driver),
    contactPerson: cleanPersonRef(data.contactPerson)
  };
};
